import jwtDecode from "jwt-decode";

export const isValidEmail = (email) => {
    const emailRegex = /^[\w\W]{1,64}([.-]?[\w\W]{1,64})*@[\w\W]{1,30}([.-]?[\w\W]{1,30})*(\.[\w\W]{2,})+$/;
    return email.match(emailRegex);
}

export const isValidName = (name) => {
    const nameRegex = /^[a-zA-ZÀ-ÿ'-]{2,50}(?: [a-zA-ZÀ-ÿ'-]{2,50})*$/;
    return name.match(nameRegex);
}

export const getUserNameFromJwt = (jwt) => {
    if (!jwt) return ""; 
    const decoded = jwtDecode(jwt);
    return decoded.name;
}

export const getUserEmailFromJwt = (jwt) => {
    if (!jwt) return "";
    const decoded = jwtDecode(jwt);
    return decoded.email;
}

export const isValidDate = (date) => date instanceof Date && !Number.isNaN(Number.parseInt(date?.getTime()?.toString(), 10));

export const humanReadableDate = (date, options) => {
    if (!isValidDate(date)) return 'Invalid date';

    const SECONDS = {
        IN_A_YEAR: 31536000,
        IN_A_MONTH: 2592000,
        IN_A_DAY: 86400,
        IN_AN_HOUR: 3600,
        IN_A_MINUTE: 60,
    };

    const { suffix = '', prefix = '', depth = 1, offset = { seconds: 60, label: 'just now' } } = options;

    let remainingSeconds = Math.floor((+new Date() - +date) / 1000);

    const years = Math.floor(remainingSeconds / SECONDS.IN_A_YEAR);
    remainingSeconds -= years * SECONDS.IN_A_YEAR;

    const months = Math.floor(remainingSeconds / SECONDS.IN_A_MONTH);
    remainingSeconds -= months * SECONDS.IN_A_MONTH;

    const days = Math.floor(remainingSeconds / SECONDS.IN_A_DAY);
    remainingSeconds -= days * SECONDS.IN_A_DAY;

    const hours = Math.floor(remainingSeconds / SECONDS.IN_AN_HOUR);
    remainingSeconds -= hours * SECONDS.IN_AN_HOUR;

    const minutes = Math.floor(remainingSeconds / SECONDS.IN_A_MINUTE);
    remainingSeconds -= minutes * SECONDS.IN_A_MINUTE;

    if (offset.seconds) {
        const dateWeight = years * SECONDS.IN_A_YEAR + months * SECONDS.IN_A_MONTH + days * SECONDS.IN_A_DAY + minutes * SECONDS.IN_A_MINUTE;
        if (dateWeight <= offset.seconds) return offset.label;
    }

    const segments = {
        year: years,
        month: months,
        day: days,
        hour: hours,
        minute: minutes,
    };

    const humanFormat = Object.entries(segments)
        .filter(([, value]) => value)
        .slice(0, depth)
        .reduce((acc, [key, value]) => {
            const formatPlural = (singularStr, number) => (number && number > 1 ? `${singularStr}s` : `${singularStr}`);
            const text = `${acc} ${value} ${formatPlural(key, value)}`;
            return text.trim();
        }, '');

    return `${prefix} ${humanFormat} ${suffix}`.trim();
};

export const getInitial = (name) => {
    if (!name) return "";
    const names = name.split(" ").filter(s => s);
    if (names.length === 1) return names[0][0].toUpperCase();
    return `${names[0][0]}${names[names.length - 1][0]}`.toUpperCase(); 
}

export const toTitleCase = (str) => {
    if (!str) return str;
    return str.toLowerCase().replace(/(?:^|\s)\w/g, match => match.toUpperCase());
  }
  